import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertService } from '../../services/alert.service';
import { TidService } from '../../services/tid.service';
import { filter } from 'rxjs/operators';
import { SubscriptionManager } from 'src/app/_helpers/subscription-manager';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  isIE = false;
  private sm = new SubscriptionManager();
  supportUrl = environment.supportUrl;
  currentYear: number;
  loginForm: FormGroup;
  loading = false;
  accounts: any[] = [];
  submitted = false;
  selectedAccount: string = null;
  errorMessage$ = this.tidService.errorMessage$;
  accounts$ = this.tidService.accounts$.pipe(
    filter((accounts) => accounts.length > 0)
  );
  constructor(
    private alertService: AlertService,
    private tidService: TidService,
    private router: Router,
    private formBuilder: FormBuilder
  ) {
    this.currentYear = new Date().getFullYear();
  }

  ngOnInit(): void {
    this.loading = false;
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
    });

    this.sm.manage = this.accounts$.subscribe({
      next: (accounts) => {
        if (accounts) {
          this.showAccountSelector(accounts);
        }
      },
    });

    this.sm.manage = this.tidService.errorMessage.subscribe((error) => {
      if (error) {
        this.loading = false;
      }
    });

    this.isIE = /msie\s|trident\//i.test(window.navigator.userAgent);
    this.alertService.clear();
  }

  signInUsername() {
    localStorage.setItem('userName', this.f.username.value);
    this.sm.manage = this.tidService
      .checkMigrationStatus(this.f.username.value, this.router.url)
      .subscribe();
  }

  signInAccount() {
    this.sm.manage = this.tidService
      .loginWithTid(this.selectedAccount)
      .subscribe(([data, token]) => {
        this.tidService.loginSuccess(data.user, token);
      });
  }
  setSelectedAccount(): void {
    this.selectedAccount = this.accounts.length
      ? this.accounts[0].displayName
      : null;
    this.f.username.setValue(localStorage.getItem('userName'));
  }

  showAccountSelector(accounts: any[]): void {
    this.loading = false;
    accounts.forEach((el) => {
      if (!this.accounts.find((a) => a.displayName === el.displayName)) {
        this.accounts.push(el);
      }
    });
    this.setSelectedAccount();
  }

  onSelect(val: string): void {
    this.selectedAccount = val;
  }
  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }
  keydownEvent(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
    event.stopPropagation();
    this.onSubmit();
  }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }
    this.loading = true;

    this.tidService.errorMessage.next(null);
    if (!this.selectedAccount) {
      this.signInUsername();
    } else {
      this.signInAccount();
    }
  }
  openSupportPage() {
    window.open(environment.supportUrl, '_blank');
  }
  redirectSignup() {
    this.tidService.accounts$.next([]);
    this.tidService.email = '';
    this.tidService.errorMessage.next(null);
  }
  ngOnDestroy() {
    this.tidService.destroy();
    this.sm.unsubscribe();
  }
}
